import React, { useEffect, createElement } from 'react';
import { CountdownBar } from './components/CountdownBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { IncludedSection } from './components/IncludedSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FooterSection } from './components/FooterSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    const loadPixel = () => {
      const script = document.createElement('script');
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '885866990629991');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadPixel);
    } else {
      setTimeout(loadPixel, 3000);
    }
  }, []);
  return <div className="min-h-screen bg-gray-50 font-sans text-gray-900 selection:bg-yellow-300 selection:text-black" data-id="element-0">
      <CountdownBar data-id="element-1" />
      <main className="overflow-hidden pt-10" data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <IncludedSection data-id="element-6" />
        <BonusSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
      </main>
      <FooterSection data-id="element-11" />
      <SocialProofPopup data-id="element-12" />
    </div>;
}